<script setup lang="ts">
import { goToRoute } from "~/common/helpers"

/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps({
    type: {
        type: String,
        default: "button",
    },
    loading: {
        type: Boolean,
        default: false,
    },
    icon: {
        required: false,
        type: String,
    },
    to: {
        required: false,
        type: String,
        default: "",
    },
    tooltip: {
        required: false,
        type: Boolean,
        default: false,
    },
    tooltip_text: {
        required: false,
        type: String,
        default: "",
    },
})

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */

const goTo = () => {
    if (props.to) {
        goToRoute(props.to)
    }
}
</script>
<template>
    <q-btn
        :type="type"
        color="secondary"
        @click="goTo"
        :loading="loading"
        :icon="icon"
        no-caps
        class="tw-rounded-[3px]"
    >
        <template #loading>
            <Loader
                v-if="loading"
                color="white"
                size="1.5rem"
                tooltip="Cargando..."
            />
        </template>
        <slot />
        <slot name="tooltip">
            <q-tooltip v-if="tooltip" anchor="bottom left" self="bottom left">
                {{ tooltip_text }}
            </q-tooltip>
        </slot>
    </q-btn>
</template>
